import MarketplaceLicenseApi from '@/api/marketplace-license'

// BOO-630 — admin marketplace license state. Mirrors the scim-api-key module:
// list/pagination/isLoading, with actions wrapping each API call in a loading flag.
const marketplaceLicense = {
  namespaced: true,
  state: {
    licenses: [],
    pagination: null,
    isLoading: false,
    products: [],
  },
  mutations: {
    setLicenses(state, { licenses, pagination }) {
      state.licenses = licenses
      state.pagination = pagination
    },
    setLoading(state, loading) {
      state.isLoading = loading
    },
    setProducts(state, products) {
      state.products = products
    },
  },
  actions: {
    async fetchLicenses({ commit }, { status, marketplace, search, page, limit } = {}) {
      commit('setLoading', true)
      try {
        // Only send filters that are actually set — vue-resource serializes an
        // `undefined` value as the literal string "undefined" in the query, which
        // a backend equality filter would match against and return zero rows.
        const params = { page, limit }
        if (status) params.status = status
        if (marketplace) params.marketplace = marketplace
        if (search) params.search = search
        const { data: licenses, pagination } = await MarketplaceLicenseApi.listLicenses(params)
        commit('setLicenses', { licenses, pagination })
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    // The lifetime Stripe products a license can grant, for the create-modal
    // picker. Sourced from the Stripe mirror so a new product needs no admin code.
    async fetchProducts({ commit }) {
      const { data } = await MarketplaceLicenseApi.listProducts()
      commit('setProducts', data || [])
    },
    async createLicense({ commit }, payload) {
      commit('setLoading', true)
      try {
        return await MarketplaceLicenseApi.createLicense(payload)
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    async revokeLicense({ commit }, { id }) {
      commit('setLoading', true)
      try {
        return await MarketplaceLicenseApi.revokeLicense(id)
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    async deleteLicense({ commit }, { id }) {
      commit('setLoading', true)
      try {
        return await MarketplaceLicenseApi.deleteLicense(id)
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
  },
}

export default marketplaceLicense
